import { getTarget } from "../functions/_getTarget";

export const setupAnchorScroll = (): void => {
  document
    .querySelectorAll<HTMLElement>("[data-anchor-scroll]")
    .forEach((e) => {
      e.addEventListener("click", (ev) => {
        const target = getTarget(e);

        if (target === "top") {
          ev.preventDefault();
          gsap.to(window, {
            scrollTo: {
              y: 0
            }
          });
        } else if (target) {
          ev.preventDefault();
          gsap.to(window, {
            scrollTo: {
              y: target
            }
          });
        }
      });
    });
};
